import React, { useCallback } from 'react';
import { Slider, Rail, Handles, Tracks } from 'react-compound-slider';
import { SliderRail, Handle, Track } from './slidercomponents';
import { debounce } from 'lodash';

const sliderStyle = {
  position: 'relative',
  width: '100%',
};

const domain = [0, 255];

export function SliderControl(props) {
  const updateDebounced = useCallback(debounce(onUpdate, 25), [props]);
  const onChangeDebounced = useCallback(debounce(onChange, 25), [props]);
  function onUpdate(params) {
    props.setSliderValues(params);
  }

  //onMouseUp on slider
  function onChange(params) {
    props.updateSliderValues(params);
  }

  return (
    <div>
      <div style={{ height: 30, width: '100%' }}>
        <Slider
          mode={2}
          step={1}
          domain={domain}
          rootStyle={sliderStyle}
          onUpdate={updateDebounced}
          onChange={onChangeDebounced}
          values={[props.lowerLevelLimit, props.upperLevelLimit]}
          disabled={props.disabled}
        >
          <Rail>{({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}</Rail>
          <Handles>
            {({ handles, getHandleProps }) => (
              <div className="slider-handles">
                {handles.map((handle) => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    domain={domain}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => (
              <div className="slider-tracks">
                {tracks.map(({ id, source, target }) => (
                  <Track
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Tracks>
        </Slider>
      </div>
    </div>
  );
}
